import { useQuery } from 'react-query';
import useContext from '../../hooks/useContext';
import { SiteContext } from '../../SiteContext';
import { get } from '../fetch';
import { appendPreviewDate } from '../helper';

export const useGetPostalInformation = (postal: string | null) => {
  const {
    data: { searchServiceUrl },
  } = useContext(SiteContext);
  const url = appendPreviewDate(`${searchServiceUrl}/zipcodes/${postal}`);

  return useQuery(['postal-info', postal], () => get<IPostalInformation>(url), {
    enabled: !!postal,
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
  });
};
